import { OnInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';

import { ZeroDollarCheckDeposit } from '../../../models/zerodollarcheckdeposit.model';

@Component({
  selector: 'app-create-zerodollar-check',
  templateUrl: './create-zerodollar-check.component.html',
  styleUrls: ['./create-zerodollar-check.component.css'],
})

export class CreateZeroDollarCheckComponent implements OnInit {
  yearRange = `1970:${new Date().getFullYear()}`;
  zeroDollarCheckDepositForm: FormGroup;
  currentDate = new Date();
  @Input() parentForm: FormGroup;
  @Input() displayZeroDollarCheckModal: boolean;
  @Input() zeroDollarCarrierId: string;
  @Input() zeroDollarCheckNumber: string;
  @Input() zeroDollarDepositDate: string;
  @Input() zeroDollarCarrierSelections: SelectItem[];
  
  zeroDollarCheckDepositResult: ZeroDollarCheckDeposit;
  disableSubmitButton: boolean = true;
  @Output() onModalCancel: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onModalAction: EventEmitter<ZeroDollarCheckDeposit> = new EventEmitter<ZeroDollarCheckDeposit>();
  @ViewChild('zeroDollarCheckCancelButton') zeroDollarCheckCancelButton: ElementRef;
  @ViewChild('zeroDollarCheckCheckNumber') zeroDollarCheckNumberField: ElementRef;

  constructor(
    private fb: FormBuilder
    ) {
      this.initZeroDollarCheckDepositFormData();
    }

  initZeroDollarCheckDepositFormData(): void {
    this.disableSubmitButton = true;
    this.zeroDollarCheckDepositForm = this.fb.group({
      zeroDollarCarrierControl : this.fb.control(null),
      zeroDollarCheckNumber : this.fb.control(null),
      zeroDollarDepositDate : this.fb.control(null),
    });
  } 

  ngOnInit(): void {
    if(this.zeroDollarCarrierId != null){
      this.zeroDollarCheckDepositForm.controls['zeroDollarCarrierControl'].setValue(this.zeroDollarCarrierId);
    }
    else if(this.zeroDollarCheckNumber != null){
      this.zeroDollarCheckDepositForm.controls['zeroDollarCheckNumber'].setValue(this.zeroDollarCheckNumber);
    }
    else if(this.zeroDollarDepositDate != null){
      this.zeroDollarCheckDepositForm.controls['zeroDollarDepositDate'].setValue(this.zeroDollarDepositDate);
    }
      
    this.disableSubmitButton = true;

    this.zeroDollarCheckDepositForm.valueChanges.subscribe(selectedValue => {
      if((this.zeroDollarCheckDepositForm.controls['zeroDollarCarrierControl'].value && this.zeroDollarCheckDepositForm.controls['zeroDollarCarrierControl'].valid) &&
      (this.zeroDollarCheckDepositForm.controls['zeroDollarCheckNumber'].value && this.zeroDollarCheckDepositForm.controls['zeroDollarCheckNumber'].valid) &&
      (this.zeroDollarCheckDepositForm.controls['zeroDollarDepositDate'].value && this.zeroDollarCheckDepositForm.controls['zeroDollarDepositDate'].valid)){
          this.disableSubmitButton = false;
      }
      else{
        this.disableSubmitButton = true;
      }
    });
  } 

  cancelClick() {
    this.disableSubmitButton = true;
    this.zeroDollarCheckDepositForm.reset();
    this.onModalCancel.emit(true);
  }

  submitClick() {
    this.zeroDollarCheckDepositResult = new ZeroDollarCheckDeposit(
      this.zeroDollarCheckDepositForm.controls['zeroDollarCarrierControl'].value,
      this.zeroDollarCheckDepositForm.controls['zeroDollarCheckNumber'].value,
      this.zeroDollarCheckDepositForm.controls['zeroDollarDepositDate'].value
    );

    this.onModalAction.emit(this.zeroDollarCheckDepositResult);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/deposit-search/create-zerodollar-check/create-zerodollar-check.component.ts